module.exports = __webpack_public_path__ + "fonts/HKNova-Bold.1948f674.woff";